import Confetti from 'react-confetti';
import React from 'react';
import { PlainModal, PlainModalProps } from './modal';
import { Typography } from '../typography/typography';

export type ConfettiModalProps = PlainModalProps & {
  title?: string;
  children: React.ReactNode;
  width?: number;
  height?: number;
};

export const ConfettiModal = (p: ConfettiModalProps) => (
  <PlainModal {...p}>
    <div className="text-center">
      <Confetti
        width={p?.width || 669}
        height={p?.height || 400}
        numberOfPieces={100}
        opacity={0.7}
      />
      {p.title ? (
        <Typography variant="display" size="small">
          {p.title}
        </Typography>
      ) : null}
      {p.children}
    </div>
  </PlainModal>
);
